// extracted by mini-css-extract-plugin
export default {"heading":"ReportingDetailsIndicatorsEditTemplate_heading__s-O0n","buttonLink":"ReportingDetailsIndicatorsEditTemplate_buttonLink__dkk81"};